import QUERY_KEYS from '@/constants/query-keys';
import api from '@/lib/api';

interface TonKhoDauKyVatTuSanPhamResponse<T = any> {
  results: T[];
  count: number;
}

export const fetchAllTonKhoDauKyVatTuSanPham = async (
  entitySlug: string,
  params: Record<string, any> = {},
  pageSize = 200
): Promise<any[]> => {
  let page = 1;
  let all: any[] = [];
  let totalCount = 0;

  while (true) {
    const response = await api.get<TonKhoDauKyVatTuSanPhamResponse>(
      `/entities/${entitySlug}/erp/${QUERY_KEYS.TON_KHO_DAU_KY_VAT_TU_SAN_PHAM}/`,
      {
        params: {
          ...params,
          page,
          page_size: pageSize
        }
      }
    );

    const pageResults = response.data.results || [];
    totalCount = response.data.count ?? totalCount;
    all = all.concat(pageResults);

    if (!pageResults.length) {
      break;
    }

    if (totalCount && all.length >= totalCount) {
      break;
    }

    page += 1;
  }

  return all;
};
